module.exports = __webpack_public_path__ + "static/media/medium.5332507e.png";